import { render, staticRenderFns } from "./class-schedule.vue?vue&type=template&id=b180a808&scoped=true"
import script from "./class-schedule.vue?vue&type=script&lang=js"
export * from "./class-schedule.vue?vue&type=script&lang=js"
import style0 from "./class-schedule.vue?vue&type=style&index=0&id=b180a808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b180a808",
  null
  
)

export default component.exports